<template>
    <div>
      <component :is="resolvedComponent" />
    </div>
  </template>
  
  <script>
  export default {
    name: 'DynamicComponentView',
    props: {
      componentName: {
        type: String,
        required: true,
      }
    },
    data() {
      return {
        resolvedComponent: null,
      };
    },
    created() {
      this.loadComponent();
    },
    watch: {
      componentName: 'loadComponent',
    },
    methods: {
      async loadComponent() {
        try {
          const componentMap = {
            // Views
            MainView: () => import('@/views/MainView.vue'),
            ToolDescriptionPageView: () => import('@/views/ToolDescriptionPageView.vue'),
            HomeView: () => import('@/views/HomeView.vue'),
            StepperView: () => import('@/views/StepperView.vue'),
            SolutionDetailsView: () => import('@/views/SolutionDetailsView.vue'),
            LogInMaskView: () => import('@/views/LogInMaskView.vue'),
            RegisterMaskView: () => import('@/views/RegisterMaskView.vue'),

            // Components
            MainHeader: () => import('@/components/MainHeader.vue'),
            Footer: () => import('@/components/Footer.vue'),
            Chatbot: () => import('@/components/Chatbot.vue'),
            ToolDescriptionContent: () => import('@/components/ToolDescriptionContent.vue'),
            Stepper: () => import('@/components/Stepper/Stepper.vue'),
            StepperHeading: () => import('@/components/Stepper/StepperHeading.vue'),
            SolutionDetails: () => import('@/components/solution_details/SolutionDetails.vue'),
            HomeContent: () => import('@/components/HomeContent.vue'),
            Playground: () => import('@/components/Playground.vue'),
            LogInMask: () => import('@/components/LogInMask.vue'),
            RegisterMask: () => import('@/components/RegisterMask.vue'),
            
            
            // Weitere mögliche Komponenten oder Views
            // ComponentName: () => import('@/components/ComponentName.vue'),
          };

          if (componentMap[this.componentName]) {
            this.resolvedComponent = (await componentMap[this.componentName]()).default;
          } else {
            console.error(`Komponente "${this.componentName}" nicht gefunden.`);
          }
        } catch (error) {
          console.error('Fehler beim Laden der Komponente:', error);
        }
      }
    }
  };
  </script>
  
  <style scoped>
  /* Optionales Styling */
  </style>
  